import React, { useEffect, useState } from "react";
import { api, API_BASE } from "../lib/api";

/**
 * Authenticated <img> that fetches the file as a blob with credentials.
 * Path is the storage_path returned by /api/files/upload.
 */
export default function AuthImg({ path, className, alt = "", testid }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url = "";
    let cancelled = false;
    (async () => {
      try {
        const resp = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        url = URL.createObjectURL(resp.data);
        setSrc(url);
      } catch {
        // leave empty
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!src) {
    return (
      <div
        className={`bg-slate-200 border-2 border-slate-300 grid place-items-center text-slate-400 text-xs ${className || ""}`}
        data-testid={testid}
      >
        IMG
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
}

export const FILE_BASE = `${API_BASE}/files`;
